export * from './camera-stream-view.component';
